export interface IDemand {
    _id: string,
    name: string,
    AdvertisingSystem: string,
    PubAccId: {id:string,caId?:string,description:string}[];
    globalBundleWhiteList: string[],
    globalBundleBlackList: string[],
    extraAdsTxt?: string[]
}

export const initialDemandObj:IDemand = {
    _id: null,
    name: null,
    AdvertisingSystem: null,
    PubAccId: [],
    globalBundleWhiteList: [],
    globalBundleBlackList: [],
    extraAdsTxt: []
};
